import React, { useState } from "react";
import {
  Grid,
  Typography,
  Paper,
  Box,
  Divider,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createBookingPackage } from "../../Redux/Slice/SpecialPackage";
// import SEO from "../../SEO";

const genderList = ["Male", "Female", "Other"];
const cityList = ["Dubai", "Abu Dhabi"];
const countryCodes = ["+971", "+91", "+44", "+1"];

const mobileValidationRules = {
  "+971": 9,
  "+91": 10,
  "+44": 10,
  "+1": 10,
};

const BookingForm = ({ formData, setFormData, onNext, packageId, pkg }) => {
  const dispatch = useDispatch();
  // const location = useLocation();
  const navigate = useNavigate();
  // const { packageId } = useParams();
  // const pkg = location.state;

  console.log("pack", packageId, pkg);

  const { loading } = useSelector((state) => state?.packages?.booking);

  const [errors, setErrors] = useState({});
  const [countryCode, setCountryCode] = useState(
    formData.countryCode || "+971"
  );
  const [mobileNo, setMobileNo] = useState(formData.mobileNo || "");
  const [date, setDate] = useState(formData.date || "");

  if (!pkg) {
    navigate("/special-packages");
    return null;
  }

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only digits
    const maxLength = mobileValidationRules[countryCode] || 10;
    if (value.length <= maxLength) {
      setMobileNo(value);
      setFormData({ ...formData, mobileNo: value });
      setErrors((prev) => ({ ...prev, mobileNo: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const maxLength = mobileValidationRules[countryCode] || 10;

    if (!formData.name?.trim()) newErrors.name = "Full name is required";
    if (!formData.gender) newErrors.gender = "Please select gender";
    if (!formData.city) newErrors.city = "Please select city";
    if (!date) newErrors.date = "Please select appointment date";
    if (!mobileNo) newErrors.mobileNo = "Please enter mobile number";
    else if (mobileNo.length !== maxLength)
      newErrors.mobileNo = `Mobile number must be ${maxLength} digits for ${countryCode}`;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formattedDate = dayjs(date).format("YYYY-MM-DD");

    dispatch(
      createBookingPackage({
        name: formData.name,
        gender: formData.gender,
        city: formData.city,
        mobileNo: `${countryCode}${mobileNo}`,
        appointmentDate: formattedDate,
        packageId,
      })
    ).then(() => {
      onNext();
    });
  };

  return (
    <>
      <Grid container justifyContent="center" sx={{ py: 6, px: 2 }}>
        <Paper
          elevation={4}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "100%",
            maxWidth: "1000px",
            borderRadius: 3,
            overflow: "hidden",
          }}
        >
          {/* Left Section - Package Info */}
          <Box
            sx={{
              flex: 1,
              backgroundColor: "#f0f4f8",
              p: 4,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="h5" fontWeight={600} gutterBottom>
              {pkg.packageName}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Facility: {pkg.packageFacility}
            </Typography>
            <Typography variant="body2" gutterBottom>
              Description:
            </Typography>
            <Typography
              variant="body2"
              sx={{ whiteSpace: "pre-line" }}
              gutterBottom
            >
              {pkg.packageDescrption}
            </Typography>
            <Typography variant="subtitle1" fontWeight={600} mt={2}>
              Amount: {pkg.amount} AED
            </Typography>
          </Box>

          {/* Right Section - Booking Form */}
          <Box
            sx={{
              flex: 1,
              p: 4,
              backgroundColor: "#fff",
            }}
          >
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Book This Package
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit} noValidate>
              {/* Full Name */}
              <TextField
                label="Full Name"
                size="small"
                fullWidth
                required
                value={formData.name || ""}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                error={!!errors.name}
                helperText={errors.name}
                margin="dense"
              />

              {/* Gender */}
              <TextField
                select
                label="Gender"
                size="small"
                fullWidth
                required
                value={formData.gender || ""}
                onChange={(e) =>
                  setFormData({ ...formData, gender: e.target.value })
                }
                error={!!errors.gender}
                helperText={errors.gender}
                margin="dense"
              >
                {genderList.map((g) => (
                  <MenuItem key={g} value={g}>
                    {g}
                  </MenuItem>
                ))}
              </TextField>

              {/* City */}
              <TextField
                select
                label="City"
                size="small"
                fullWidth
                required
                value={formData.city || ""}
                onChange={(e) =>
                  setFormData({ ...formData, city: e.target.value })
                }
                error={!!errors.city}
                helperText={errors.city}
                margin="dense"
              >
                {cityList.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </TextField>

              {/* Appointment Date */}
              <TextField
                label="Appointment Date"
                type="date"
                size="small"
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
                value={date}
                onChange={(e) => {
                  setDate(e.target.value);
                  setFormData({ ...formData, date: e.target.value });
                }}
                error={!!errors.date}
                helperText={errors.date}
                margin="dense"
              />

              {/* Mobile Number */}
              <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                <TextField
                  select
                  label="Code"
                  size="small"
                  sx={{ width: "30%" }}
                  value={countryCode}
                  onChange={(e) => {
                    setCountryCode(e.target.value);
                    setFormData({ ...formData, countryCode: e.target.value });
                    setMobileNo("");
                    setErrors((prev) => ({ ...prev, mobileNo: "" }));
                  }}
                >
                  {countryCodes.map((code) => (
                    <MenuItem key={code} value={code}>
                      {code}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Mobile Number"
                  size="small"
                  sx={{ width: "70%" }}
                  value={mobileNo}
                  onChange={handleMobileChange}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  required
                  error={!!errors.mobileNo}
                  helperText={errors.mobileNo}
                />
              </Box>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  mt: 3,
                  borderRadius: 2,
                  height: 40,
                  textTransform: "none",
                }}
                disabled={loading}
              >
                {loading ? "Booking..." : "Book Package"}
              </Button>
            </form>
          </Box>
        </Paper>
      </Grid>
    </>
  );
};

export default BookingForm;
